import React from "react";
import VehicleSlider from "../pages/VehicleSlider";
import TrustedPartner from "../pages/TrustedPartner";

const Aboutus = () => {
  return (


<>




  <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  About Us
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>







    <section className="your-dream-one section-space">
      <div className="container">
        <div className="row gutter-y-40">
          <div className="col-lg-6">
            <div
              className="your-dream-one__thumb wow fadeInLeft"
              data-wow-duration="1500ms"
              data-wow-delay="500ms"
            >
              <div className="your-dream-one__thumb__item">
                <img
                  src="/images/about.png"
                  alt="image"
                />
              </div>

       

              <div className="your-dream-one__element-four">
                <img
                  src="/images/shapes/truse-1-1.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="your-dream-one__container">
              <div className="sec-title sec-title--two text-start">
                <h6 className="sec-title__tagline bw-split-in-right">
                  About Us
                </h6>
                <h3 className="sec-title__title bw-split-in-left">
                  Your Journey Begins with Sanavi Travels
                </h3>
              </div>

              <p
                className="your-dream-one__text wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="500ms"
              >
                Sanavi Travels is your trusted partner in creating memorable travel experiences. We are passionate about helping travelers explore new destinations with comfort, convenience, and confidence. Whether you are planning a family vacation, a business trip, a romantic getaway, or a group tour, we are committed to making your journey smooth and enjoyable from start to finish.

With a strong focus on customer satisfaction, Sanavi Travels offers personalized travel solutions tailored to your needs and preferences. From flight bookings and hotel reservations to holiday packages and travel assistance, our experienced team ensures every detail is handled with care and professionalism.

At Sanavi Travels, we believe that travel is more than just reaching a destination—it’s about the experiences, memories, and stories you create along the way. Our mission is to provide reliable services, competitive pricing, and exceptional support, so you can travel worry-free and focus on enjoying your journey.
              </p>

            </div>
          </div>
        </div>
      </div>

      <div className="your-dream-one__element-one">
        <img
          src="/images/shapes/truse-1-3.png"
          alt=""
        />
      </div>

      <div className="your-dream-one__element-two">
        <img
          src="/images/shapes/truse-1-1.png"
          alt=""
        />
      </div>

      <div className="your-dream-one__element-three">
        <img
          src="/images/shapes/truse-1-2.png"
          alt=""
        />
      </div>
    </section>
    <TrustedPartner/>
<VehicleSlider/>
</>
  );
};

export default Aboutus;
